<template>
  <div>
    <div v-show="adminLives.length" class="gutter-b">
      <div class="row">
        <div
          v-for="live in adminLives"
          :key="live.id"
          class="col-md-4 gutter-b"
        >
          <div v-if="live.program" class="card h-100">
            <div class="card-header py-2">
              <router-link
                :to="{
                  name: 'admin-programs-show',
                  params: { id: live.program_id }
                }"
              >
                {{ live.program.name }}
              </router-link>
            </div>
            <div class="card-body p-0">
              <router-link
                :to="{
                  name: 'admin-lives-show',
                  params: {
                    program: live.program_id,
                    live: live.id
                  }
                }"
              >
                <LiveImage :live="live"></LiveImage>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="overflow-auto mt-5" v-if="adminLivesPagination.lastPage > 1">
        <b-pagination
          v-model="adminLivesPagination.currentPage"
          :total-rows="adminLivesPagination.total"
          :per-page="adminLivesPagination.perPage"
          aria-controls="my-table"
          @input="getLives()"
        ></b-pagination>
      </div>
    </div>
    <div v-if="adminLives.length === 0">
      <div class="alert alert-primary" role="alert">پخش فعالی یافت نشد.</div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import { mapGetters } from "vuex";
import { FETCH_ADMIN_LIVES } from "@/core/services/store/admin/lives.module";
import LiveImage from "@/view/content/widgets/LiveImage";

export default {
  name: "admin-dashboard",
  components: {
    LiveImage
  },
  data() {
    return {
      interval: null,
      livesLoaded: false
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "مدیریت",
        route: { name: "admin-dashboard" }
      },
      { title: "پخش های فعال" }
    ]);
    this.$store.dispatch(SET_ACTIONS, {});
    this.getLives();
    this.interval = setInterval(this.getLives, 30000);
  },
  destroyed() {
    clearInterval(this.interval);
    this.interval = null;
  },
  computed: {
    ...mapGetters(["adminLives", "adminLivesPagination"])
  },
  methods: {
    getLives(first = false) {
      this.livesLoaded = false;
      if (first) {
        this.$store.state.adminLives.adminLivesPagination.currentPage = 1;
      }

      this.$store
        .dispatch(FETCH_ADMIN_LIVES, {
          status: 0
        })
        .then(() => {
          this.livesLoaded = true;
        })
        .catch(() => {
          this.livesLoaded = true;
        });
    }
  }
};
</script>
